package com.hyperether.goodjob.util

import com.hyperether.goodjob.models.Contact
import com.hyperether.goodjob.models.Site

object ContactUtil {
    fun isSiteCreatedFromContact(site: Site, contact: Contact): Boolean {
        return site.parentId == contact.id &&
                site.workspaceId == contact.workspaceId &&
                site.personName == (contact.personName?.takeIf { it.isNotEmpty() } ?: contact.name) &&
                site.personEmail == (contact.personEmail?.takeIf { it.isNotEmpty() } ?: contact.email) &&
                site.personPhone == (contact.personPhone?.takeIf { it.isNotEmpty() } ?: contact.phone) &&
                site.addressObject == contact.addressObject &&
                site.parentName == contact.name
    }

}